/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentState } from './PaymentState';
import {
    PaymentStateFromJSON,
    PaymentStateFromJSONTyped,
    PaymentStateToJSON,
    PaymentStateToJSONTyped,
} from './PaymentState';

/**
 * 
 * @export
 * @interface InitiatePaymentResponse
 */
export interface InitiatePaymentResponse {
    /**
     * 
     * @type {PaymentState}
     * @memberof InitiatePaymentResponse
     */
    paymentState: PaymentState;
    /**
     * 
     * @type {number}
     * @memberof InitiatePaymentResponse
     */
    paymentId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof InitiatePaymentResponse
     */
    qrCodeData?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InitiatePaymentResponse
     */
    redirectUrl?: string | null;
}



/**
 * Check if a given object implements the InitiatePaymentResponse interface.
 */
export function instanceOfInitiatePaymentResponse(value: object): value is InitiatePaymentResponse {
    if (!('paymentState' in value) || value['paymentState'] === undefined) return false;
    return true;
}

export function InitiatePaymentResponseFromJSON(json: any): InitiatePaymentResponse {
    return InitiatePaymentResponseFromJSONTyped(json, false);
}

export function InitiatePaymentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitiatePaymentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentState': PaymentStateFromJSON(json['paymentState']),
        'paymentId': json['paymentId'] === undefined ? undefined : json['paymentId'] === null ? null : json['paymentId'],
        'qrCodeData': json['qrCodeData'] === undefined ? undefined : json['qrCodeData'] === null ? null : json['qrCodeData'],
        'redirectUrl': json['redirectUrl'] === undefined ? undefined : json['redirectUrl'] === null ? null : json['redirectUrl'],
    };
}

export function InitiatePaymentResponseToJSON(json: any): InitiatePaymentResponse {
    return InitiatePaymentResponseToJSONTyped(json, false);
}

export function InitiatePaymentResponseToJSONTyped(value?: InitiatePaymentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentState': PaymentStateToJSON(value['paymentState']),
        'paymentId': value['paymentId'],
        'qrCodeData': value['qrCodeData'],
        'redirectUrl': value['redirectUrl'],
    };
}

